<script>
    import {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import user from "../stores/user";
    import {APP_VERSION, USER_ROLES} from "../lib/constants";
    import {clickOutside} from "../lib/clickOutside";
    import AppIcon from "./icons/AppIcon.svelte";

    let showUserDropdown = false;

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeUserDropdown();
        }
    }

    const logOut = () => {
        user.clearToken();
        window.location.href = "/app";
        // router.go('/app')();
    }

    const gotoPassports = () => {
        router.go('/app/passports')();
    }

    const toggleMenu = () => {
        $app.menuExpanded = $app.menuExpanded > 0 ? 0 : 2;
    }

    const toggleUserDropdown = () => {
        if (!showUserDropdown) {
            showUserDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        } else {
            closeUserDropdown();
        }
    }

    const closeUserDropdown = () => {
        showUserDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
    }
</script>

<header>
    <div class="content">
        <div class="content-left">
            <div class="menu-icon" on:click="{ toggleMenu }">
                <AppIcon icon="menu" size="24"/>
            </div>
            <div class="brand">
                <img src="/assets/images/app-logo.png" alt="logo">
                <div class="version">ver { APP_VERSION }</div>
            </div>
        </div>
        <div class="content-right">
            {#if user.isAdmin()}
            <div class="content-item item-button border-left" on:click={ gotoPassports }>
                <AppIcon icon="passport" size="18"/>
                {#if $app.passports_for_sync > 0}
                    <div class="badge">{ $app.passports_for_sync }</div>
                {/if}
            </div>
                {/if}
            <div class="content-item dropdown-container border-left" on:click="{ toggleUserDropdown }">
                <div class="user">
                    { user.acronym() }
                </div>
                {#if showUserDropdown}
                    <ul class="dropdown right" use:clickOutside
                        on:click_outside="{ closeUserDropdown }">
                        <li class="p-3">
                            <div class="fs-6">{ $user.name }</div>
                            <div class="text-muted">{ USER_ROLES[$user.role_id] }</div>
                        </li>
                        <li class="separator"></li>
                        <li class="dropdown-item pointer text-center" on:click="{ logOut }">
                            Αποσύνδεση
                        </li>
                    </ul>
                {/if}
            </div>
        </div>
    </div>
</header>

<style>
    header {
        position: fixed;
        display: flex;
        align-items: center;
        height: var(--header-height);
        background: #fff;
        border-bottom: 1px solid #c6d2d9;
        width: 100%;
        z-index: 9000;
    }

    header .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

    header .brand {
        position: relative;
    }

    header .brand .version {
        position: absolute;
        bottom: -8px;
        right: -3px;
        font-size: 9px;
        line-height: 1;
        color: #464646;
        background: #fff;
        padding: 0 5px;
    }

    header .menu-icon {
        color: #333;
        padding: 5px 10px;
        cursor: pointer;
    }

    @media (min-width: 992px) and (max-width: 1024px) {
        header .menu-icon {
            margin-left: 7px;
        }
    }

    @media (min-width: 1025px) {
        header .menu-icon {
            display: none;
        }
    }

    .content-left, .content-right {
        display: flex;
        align-items: center;
        margin-right: 15px;
    }

    header .content-left .brand {
        /*height: 20px;*/
        /*padding: 0 10px;*/
    }

    header .content-left .brand img {
        /*height: 100%;*/
        width: 100%;
    }

    .content-item {
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 15px;
    }

    .content-item .badge {
        position: absolute;
        bottom: -5px;
        right: 5px;
        background: red;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        font-size: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
    }


    .content-item:last-of-type {
        padding-right: 0;
    }

    .content-item.border-left {
        border-left: 1px dotted #c6d2d9;
    }

    :global(.content-item.item-button) {
        cursor: pointer;
        height: 30px;
        padding-left: 10px !important;
        padding-right: 15px !important;
    }

    :global(.content-item.item-button>a) {
        color: #90a4ae;
    }

    header .content-right .user {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        color: #fff;
        background: #ffc107;
        border-radius: 50%;
        padding: 0;
        cursor: pointer;
    }


    @media (min-width: 768px) and (max-width: 991px) {
    }

    @media (min-width: 992px) {

    }

    @media (max-width: 576px) {
        header .content-left .brand {
            width: 140px;
        }
    }

    @media (min-width: 577px) {
        .content-item {
            padding: 0 20px;
        }
    }

    @media (min-width: 577px) and (max-width: 767px) {

    }

    @media (min-width: 768px) and (max-width: 991px) {
        header .content-left .brand {
            width: 140px;
        }
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        header .content-left .brand {
            width: 140px;
        }
    }

    @media (min-width: 1200px) {
        header .content-left .brand {
            margin-left: 20px;
            width: 160px;
        }

    }
</style>